export enum URL {
  HOME = "/",
  PHARMACY_LIST = "/pharmacy/list",
  PHARMACY_DETAILS = "/pharmacy/details",
  NOT_FOUND = "/404",
}

export enum FORMULARY_URL {
  HOME = "/:formulary",
  PHARMACY_LIST = "/:formulary/pharmacy/list",
  PHARMACY_DETAILS = "/:formulary/pharmacy/details",
}
